import { QuestionIcon, TextIcon, VideoIcon } from "common/assets/icons";
import * as React from "react";
import style from "./KurssloeyfeElementIcon.module.css";

interface Props {
  // TODO: Use specific enum type from schema instead of string.
  elementType: "Video" | "Article" | "MultipleChoice";
}

export const KurssloeyfeElementIcon: React.FC<
  React.PropsWithChildren<Props>
> = ({ elementType }) => {
  if (elementType === "MultipleChoice") {
    return <QuestionIcon className={style.icon} />;
  }
  if (elementType === "Video") {
    return <VideoIcon className={style.icon} />;
  }
  return <TextIcon className={style.icon} />;
};
